import { StyleSheet, View } from "react-native";
import CustomText from "../components/common/general/CustomText/CustomText";
import LtiNotConfiguredIcon from "../components/svgs/common/LtiNotConfiguredIcon";

function LTINotConfiguredState() {
  return (
    <View style={styles.previewShell}>
      <View style={styles.iframeShell}>
        <View style={styles.iframeContent}>
          <View style={styles.centerContent}>
            <View style={styles.card}>
              <View style={styles.iconWrapper}>
                <View style={styles.iconCircle}>
                  <LtiNotConfiguredIcon size={32} color="#0B69A3" />
                </View>
              </View>

              <CustomText
                text="lti.notConfigured.title"
                size="xl"
                weight="bold"
                role="heading"
                aria-level={1}
                style={styles.title}
              />

              <CustomText text="lti.notConfigured.description" size="m" style={styles.description} />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  previewShell: {
    flex: 1,
    width: "100%",
    justifyContent: "center",
    paddingHorizontal: 24,
    paddingVertical: 24,
    backgroundColor: "#F5F6F8",
    borderRadius: 12,
  },
  iframeShell: {
    width: "100%",
    maxWidth: 900,
    height: 600,
    alignSelf: "center",
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#D0D5DD",
    backgroundColor: "#F9FAFB",
    overflow: "hidden",
  },
  iframeContent: {
    flex: 1,
    padding: 24,
  },
  centerContent: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  card: {
    width: "100%",
    maxWidth: 576,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: "#D0D5DD",
    backgroundColor: "#FFFFFF",
    paddingHorizontal: 32,
    paddingVertical: 40,
    alignItems: "center",
    justifyContent: "center",
    shadowColor: "#101828",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.06,
    shadowRadius: 2,
    elevation: 1,
  },
  iconWrapper: {
    width: "100%",
    alignItems: "center",
    marginBottom: 8,
  },
  iconCircle: {
    width: 80,
    height: 80,
    borderRadius: 40,
    backgroundColor: "#E7F3FB",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    textAlign: "center",
    maxWidth: 500,
  },
  description: {
    marginTop: 12,
    textAlign: "center",
    color: "#475467",
    maxWidth: 560,
    lineHeight: 24,
  },
});

export default LTINotConfiguredState;
